import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
  user: {
    FullName: '姓名',
    FirstName: '名',
    LastName: '姓',
    Email: '电子邮箱',
    OldPassword: '初始密码',
    Password: '密码',
    NewPassword: '新密码',
    ConfirmPassword: '确认密码',
    Title: '职位',
    Company: '公司',
    SignUp: '注册',
    SignIn: '登录',
    ChangePassword: '修改密码',
    ForgotPassword: '忘记密码',
    ResetPassword: '重置密码',
    forgotPassword: '忘记密码',
    changePassword: '修改密码',
    Back: '返回',
    Logout: '退出登录',
    Name: '姓名',
    ExpirationDate: '过期时间',
    CardNumber: '卡号',
    CVV: '校验码'
  },
  menuData: [
    {
      index: '1',
      menuName: '服务平台',
      subMenu: [
        {
          index: 'dashboard',
          menuName: '首页',
          icon: 'icon-home',
          disabled: false,
          path: '/dashboard'
        }
      ]
    },
    {
      index: '2',
      menuName: '服务列表',
      subMenu: [
        {
          index: 'malware',
          menuName: '安卓病毒检测',
          icon: 'icon-mobile-malware',
          disabled: false,
          path: '/malware'
        },
        {
          index: 'wifi',
          menuName: '安卓/iOS Wifi安全扫描',
          icon: 'icon-wf',
          disabled: false,
          path: '/wifi'
        },
        {
          index: 'junk',
          menuName: '安卓垃圾清理',
          icon: 'icon-junk',
          disabled: false,
          path: '/junk'
        },
        {
          index: 'whitelist',
          menuName: '白名单',
          icon: 'icon-settings',
          disabled: false,
          path: '/whitelist',
          requiresWhitelist: true
        }
        // {
        //   index: 'url',
        //   menuName: 'URL网址安全检测',
        //   icon: 'icon-url-filtering',
        //   disabled: false,
        //   path: '/url'
        // },
        // {
        //   index: 'app',
        //   menuName: '应用深度分析',
        //   icon: 'icon-app-insight',
        //   disabled: false,
        //   path: '/app'
        // }
      ]
    },
    {
      index: '3',
      menuName: '其他',
      subMenu: [
        {
          index: 'settings',
          menuName: '设置',
          icon: 'el-icon-setting',
          path: '/settings',
          disabled: false
        },
        {
          index: 'support',
          menuName: '支持',
          icon: 'icon-support',
          disabled: false,
          path: '/support'
        }
      ]
    }
  ],
  errMsg: {
    cardNameErr: '请输入持卡者的姓名',
    cardNumberErr1: '请输入您的卡号',
    cardNumberErr2: '请输入有效的银行卡号！',
    cvvErr1: '请输入校验码',
    cvvErr2: '请输入有效的校验码！',
    cardYearErr: '请选择年份',
    cardMonthErr: '请选择月份',
    emailErr1: '请输入您的电子邮箱',
    emailErr2: '请输入有效的email邮箱！',
    passwordErr1: '请输入密码',
    passwordErr2: '密码长度为6-20位',
    confirmPasswordErr1: '请再次输入密码',
    confirmPasswordErr2: '两次密码不一致!',
    oldPasswordErr: '请输入您的初始密码',
    firstNameErr: '请输入名字',
    lastNameErr: '请输入姓氏',
    titleErr: '请输入职位',
    companyErr: '请输入公司名称',
    err1: '信息有误',
    err2: '登录错误，请重新再试.',
    err3: '抱歉，该邮箱不存在',
    tip1: '注册成功！您现在可以登录了。',
    tip2: '发送完成，请检查该email邮箱来重置密码',
    noCard: '您还未添加支付方式.'
  },
  message: {
    edit: '修改',
    update: '提交',
    confirm: '提交',
    send: '发送',
    loading: '加载中...',
    wait: '请稍后...',
    processing: '正在支付,',
    addNewCard: '添加新卡',
    switchLang: '切换语言',
    myProfile: '账户信息',
    aboutMe: '关于',
    billing: '支付信息',
    cardInformation: '信用卡信息',
    default: '设为默认卡',
    delete: '删除',
    updateInformation: '更新信息',
    registerTip: '点击注册，表示您同意Trustlook的',
    and: '以及',
    terms: '使用条款',
    privacy: '隐私策略',
    setDefaultCard: '你确定将此卡设为缺省的支付方式么?',
    deleteCard: '你确定删除此卡?',
    setSuccessfully: '设置成功',
    deleteSuccessfully: '删除成功',
    malwareUnsubscribe: '你确定取消”移动病毒检测”的订阅服务?',
    urlUnsubscribe: '你确定取消”URL网址安全检测”的订阅服务?',
    appUnsubscribe: '你确定取消”应用深度分析”的订阅服务?',
    unsubscribeSuccessfully: '已取消该订阅',
    UNSUBSCRIBE: '确定',
    CONFIRM: '确认',
    CANCEL: '取消',
    ACTION: '确定',
    DELETE: '确定',
    switchSuccessfully: '切换成功',
    addSuccessfully: '添加成功',
    updateSuccessfully: '个人信息更新成功'
  },
  name: {
    home: '首页',
    malware: '移动病毒检测',
    url: 'URL网址安全检测',
    app: '应用深度分析',
    wifi: 'Wifi安全检测',
    reportDetail: '应用深度分析详情',
    payment: '支付',
    settings: '设置',
    support: '支持'
  },
  dashboard: {
    totalApi: 'API总调用次数:',
    quotaApi: '每月API限额:',
    monthApi: '已使用API限额:',
    malwareApi: '病毒API调用次数:',
    billingCycleStartDate: '订阅周期开始:',
    billingCycleEndDate: '订阅周期结束:',
    daily: '每日柱状图',
    weekly: '每周柱状图',
    monthly: '每月柱状图',
    apiCalls: 'API调用',
    Malware: '病毒',
    day: '按天',
    week: '按周',
    month: '按月',
    malwareList: '病毒更新文件列表',
    urlList: 'URL更新文件列表',
    appList: 'App更新文件列表',
    noData: '无数据',
    licenseKey: '许可密钥:',
    packageName: '包名:',
    yourLicense: '你的许可密码:',
    noService: '您还未购买任何服务.',
    bindMessage1: '将密钥与包名绑定可以防止密钥被第三方盗用，如需更改已绑定包名，请联系我们',
    bindMessage2: '包名绑定最多需要24小时生效',
    generateKey: '生成新密钥:',
    generateKeyLimit: '* 如果需要超过20个密钥，请联系我们.',
    enableWifi: '激活Wifi安全SDK',
    wifiSecuritySDK: 'Wifi安全SDK:',
    invoice: '发票',
    deletedLicenseKeys: '已删除的许可密钥'
  },
  service: {
    malwareService: 'Malware Detection Service',
    urlService: 'URL网址测试',
    appService: '安卓动态与静态分析报告服务',
    searchtxt1: '请输入APK文件的MD5哈希值',
    searchtxt2: '请输入URL链接或域名',
    choose: '请显示"Powered by Trustlook"',
    priceCompute: '具体费用每月按API使用量结算',
    screenshot: '使用示例',
    apiLevel: '如果有任何扫描界面',
    malwareLevel: '按分析病毒更新文件数量',
    urlLevel: '按分析URL更新文件数量',
    monthly: '每月',
    one: '每次',
    select: '选择',
    subscribe: '订阅',
    download: '下载',
    unsubscribe: '取消订阅',
    each: '每个APK分析将花费大约15分钟(根据APK大小不同)',
    freetip: '免费试用期间，每次只能上传一个APK文件',
    upload: '上传',
    report: '报告',
    apkLevel: '按分析APK文件数量',
    max: '(最大128MB)',
    errType: '上传的文件类型错误'
  },
  wifi: {
    wifiService: 'Android/iOS Wifi安全扫描',
    help: '检测以下Wifi威胁',
    ARP: 'ARP欺骗',
    DNS: 'DNS欺骗',
    SSL: 'SSL剥离和拆分',
    Weak: '弱密码链接认证',
    Device: '网络设备扫描',
    free: '订阅',
    desc1: '订阅移动病毒检测后即可下载使用',
    desc2: '查询次数包含在订阅中',
    desc3: '先在首页绑定包名',
    desc4: '然后激活Wifi安全SDK即可生效',
    desc5: '支持安卓以及iOS'
  },
  junk: {
    junkService: '缓存垃圾清理 & 相似照片检测',
    func1: 'APK垃圾清理',
    func2: '缓存垃圾清理',
    func3: '日志以及临时文件清理',
    func4: '广告垃圾清理',
    func5: '残留垃圾清理',
    func6: '照片，截屏，视频，音频，文档，缩略图扫描',
    func7: '相似照片扫描',
    free: '订阅',
    desc1: '订阅移动病毒检测后即可下载使用',
    desc2: '查询次数包含在订阅中',
    desc3: '垃圾清理',
    desc4: '相似图片检测',
    desc5: '请在首页控制面板中把密钥与包名绑定'
  },
  payment: {
    pay: '支付该服务',
    payType: '支付类型',
    result: '结果',
    enterInformation: '请输入信用卡信息',
    paySuccessfully: '支付成功',
    payTip1: '您现在可以继续使用我们的安全服务，',
    payTip2: '已向您发送了一封带有订单收据的电子邮件，请检查您的收件箱。'
  },
  support: [
    {
      name: '移动病毒检测',
      subMenu: [
        {
          title: '安卓SDK和使用手册',
          url: 'https://trustlook.s3.us-west-1.amazonaws.com/saas/trustlook_cloudscan_sdk.zip'
        }
        // {
        //   title: 'RESTful API使用手册',
        //   url: 'javascript:void(0);'
        // }
      ]
    },
    {
      name: '垃圾清理',
      subMenu: [
        {
          title: '安卓SDK和使用手册',
          url: 'https://trustlook.s3.us-west-1.amazonaws.com/saas/trustlook_clean_sdk.zip'
        }
      ]
    },
    {
      name: 'WIFI安全检测',
      subMenu: [
        {
          title: '安卓/iOS SDK和使用手册',
          url: 'https://trustlook.s3.us-west-1.amazonaws.com/saas/trustlook_wifiscan_sdk.zip'
        }
      ]
    },
    {
      name: 'URL网址安全检测',
      subMenu: [
        // {
        //   title: 'SDK和使用手册',
        //   url: 'javascript:void(0);'
        // },
        {
          title: 'RESTful API使用手册',
          url:
            'https://trustlook.s3.us-west-1.amazonaws.com/saas/Trustlook+URL+Filtering+REST+API+User+Guide.pdf'
        }
      ]
    }
    // {
    //   name: '应用深度分析',
    //   subMenu: [
    //     {
    //       title: 'RESTful API使用手册',
    //       url: 'javascript:void(0);'
    //     }
    //   ]
    // },
    // {
    //   name: 'PE病毒检测',
    //   subMenu: [
    //     {
    //       title: 'SDK和使用手册',
    //       url: 'javascript:void(0);'
    //     }
    //   ]
    // },
    // {
    //   name: '勒索病毒检测',
    //   subMenu: [
    //     {
    //       title: 'SDK和使用手册',
    //       url: 'javascript:void(0);'
    //     }
    //   ]
    // },
  ],
  footer: {
    business: '商务联系:',
    technical: '技术支持:',
    // tip1: '过去12个月的病毒库文件会在8小时内准备完成.',
    // tip2: '所有每周更新的下载链接会在首页显示',
    tip1: '为了防止盗用，请把你的密钥与包名绑定',
    tip2: '如有多个包名，可为每个包名申请一个密钥并绑定',
    tip3: '过去12个月的URL列表文件会在8小时内准备完成',
    tip4: '所有每周更新的下载链接会在首页显示',
    tip5: '如果你每个月有超过10000个APK需要分析，',
    tip6: '请联系我们商务bd@trustlook.com',
    tip7: '如果你每个月有超过10000个APK需要分析，请联系我们商务  bd@trustlook.com',
    tip8: '请先在首页控制面板中把密钥与包名绑定',
    tip9: '然后激活Wifi安全SDK，才可以使用',
    development: '开发文档',
    information: '信息提示'
  },
  whitelist: {
    title: '白名单管理',
    emptyMessage: '白名单功能即将推出。',
    md5Title: 'MD5白名单查询',
    appidTitle: 'AppID白名单查询',
    certTitle: '证书SHA1白名单查询',
    md5Placeholder: '输入MD5哈希值',
    appidPlaceholder: '输入AppID (例如: com.example.app)',
    certPlaceholder: '输入证书SHA1哈希值',
    md5AddPlaceholder: '输入要添加的MD5哈希值',
    appidAddPlaceholder: '输入要添加的AppID',
    certAddPlaceholder: '输入要添加的证书SHA1哈希值',
    query: '查询',
    querying: '查询中...',
    add: '添加',
    adding: '添加中...',
    status: '状态',
    scan: '扫描结果',
    lastUpdate: '最后更新',
    scannedBy: '扫描来源',
    score: '评分',
    appid: 'AppID',
    certSha1: '证书SHA1',
    updateDate: '更新日期',
    myAdditions: '我的白名单添加记录',
    noAdditions: '您尚未添加任何项目到白名单。'
  },
  ...zhLocale
}

export default zh



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js